import { Image, Modal, Typography } from '@smartgift/frontend-toolkit';
import { Trans, useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import * as S from './style';

function ThankYouEmailsModal({ isOpen, onRequestClose, senderName }) {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      primaryButtonProps={{ onClick: onRequestClose, children: t('okay') }}
      title={t('thankYouNoteEmails')}
      size="lg"
    >
      <S.ThankYouEmailsModalWrapper>
        <S.ItemWrapper>
          <Typography variant="body1Bold">{t('keepTheConversationGoing')}</Typography>

          <Typography variant="body2">
            <Trans i18nKey="keepTheConversationTitle" components={{ b: <b /> }} />
          </Typography>
          <Typography variant="body2">
            <Trans i18nKey="keepTheConversationGoingDesc" components={{ b: <b /> }} />
          </Typography>
          <Typography variant="body2">
            <Trans i18nKey="keepTheConversationGoingDesc2" components={{ b: <b /> }} />
          </Typography>
        </S.ItemWrapper>
        <S.ItemWrapper>
          <Image src={theme.images.viaReplyPreview} />
          <S.ExampleThankYouWrapper>
            <Typography color="fg" variant="body2">
              {t('thankYouExampleSubject', {
                senderName
              })}
            </Typography>
            <S.ExampleThankYou>
              <Typography variant="caption2">{t('thankYouExampleBody')}</Typography>
            </S.ExampleThankYou>
            <S.BottomInfo>
              <span>📬</span>
              <Typography color="fg" variant="caption2">
                {t('youCanReply')}
              </Typography>
            </S.BottomInfo>
          </S.ExampleThankYouWrapper>
        </S.ItemWrapper>
      </S.ThankYouEmailsModalWrapper>
    </Modal>
  );
}

export { ThankYouEmailsModal };
